module.exports = __webpack_public_path__ + "assets/img/empty-download.8169f379.png";